
import Radio from 'vux/src/components/radio/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import cookie from 'vux/src/tools/cookie/index.js'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'


export default {
components: {
Group,
Cell,
ViewBox,
XHeader,
XButton,
Box,
XInput,
PopupRadio,
Popup,
Radio,
Checker,
CheckerItem
},
data () {
return {
title: '充值',
showPlatform: false,
platforms: [],
platform: {
value: '',
icon: '',
min_load: '',
max_load: ''
},
platforms_hash: [],
platform_key: null,
platform_show: {
desc: ''
},
amountList: [],
defaultAmountList: [
100,
200,
500,
1000
],
wechatAmountList: [
108,
218,
588,
1098
],
qqAmountList: [
100,
218,
318,
500
],
amount: 0,
name: '',
amount_index: -1,
input_amount: '',
confirm: {
show: false
},
showBankSelect: false,
banks: [],
need_bank: null,
bank_id: null,
showPayPage: false,
load_url: '',
qrcode: null,
info: {
nickname: '',
usable_gold: '',
freeze_gold: '',
financal: {
status: 0
}
},
show_list: true,
pay_click: false,
showAmountInput: false,
showChoosePlatform: false,
platform_name: '',
app_order_no: '',
order_no: '',
show_amount: 0,
bank_card_no: '',
platform_type: '',
show_amount_input: true,
showname: false,
showmobile: false,
need_name: null,
need_mobile: null,
yourname: '',
mobileno: ''
}
},
watch: {
'platform': function (newVal, oldVal) {
if (newVal !== oldVal) {
this.checkBank()
}
},
'amount': function () {
if (this.amount > 0) {
this.input_amount = ''
}
},
'input_amount': function () {
if (this.input_amount > 0) {
this.amount = 0
}
},
'$route.query.order_no': function () {
window.location.reload()
}
},
mounted () {
this.checkOrderCounts()
const self = this

if (typeof self.$route.query.platform_id === 'undefined') {
self.platform_key = 1
} else {
self.platform_key = JSON.parse(self.$route.query.platform_id)
}

self.$models.Deposit.info({
order_no: self.$route.query.order_no,
valid: self.$route.query.valid
}).then(function (platforms) {
platforms = platforms.data.data
if (typeof platforms.platform_id !== 'undefined' && platforms.platform_id !== null) {
self.platform_name = platforms.platform.name
self.showChoosePlatform = false
self.platform_key = platforms.platform.platform_id

if (platforms.platform.need_bank === 1 && platforms.platform.bank_id === '') {
self.showBankSelect = true
let banks = []
for (let id in platforms.platform.banks) {
let val = platforms.platform.banks[id]
banks = banks.concat([{
key: id,
value: val.name
}])
}
self.banks = banks
}
let platform = platforms.platforms[0]
self.platforms = self.platforms.concat({
key: platform.id,
value: platform.name,
need_bank: platform.need_bank,
bank_id: platform.bank_id,
max_load: platform.max_load,
min_load: platform.min_load,
icon: 'static/images/logo/' + platform.icon + '.png',
show: platform.hasOwnProperty('show') ? {
content: platform.show.content,
type: platform.show.type,
link: platform.show[platform.show.type]
} : null,
banks: platform.banks,
need_name: platform.need_name,
need_mobile: platform.need_mobile
})
self.platforms_hash[platforms.platform.platform_id] = platforms.platform
} else {
for (let platform of platforms.platforms) {
var mobileShow, mobileDefault
if (navigator.userAgent.match(/AppleWebKit.*Mobile.*/) !== null) {
if (navigator.userAgent.indexOf('Android') > -1) {
mobileShow = platform.android_show
mobileDefault = platform.android_default
} else {
mobileShow = platform.ios_show
mobileDefault = platform.ios_default
}
} else {
mobileShow = platform.pc_show
mobileDefault = platform.pc_default
}
var platformObj = {
show_view: Boolean(mobileShow),
default_show: Boolean(mobileDefault),
key: platform.id,
value: platform.name,
description: platform.description,
need_bank: platform.need_bank,
bank_id: platform.bank_id,
max_load: platform.max_load,
min_load: platform.min_load,
icon: 'static/images/logo/' + platform.icon + '.png',
show: platform.hasOwnProperty('show') ? {
content: platform.show.content,
type: platform.show.type,
link: platform.show[platform.show.type]
} : null,
banks: platform.banks,
amount_list: platform.custom_amounts,
static_amount: platform.static_amount,
succ_percent: platform.succ_percent,
need_name: platform.need_name,
need_mobile: platform.need_mobile
}
if (platformObj.show_view) {
self.platforms = self.platforms.concat(platformObj)
}
self.platforms_hash[platformObj.key] = platformObj

if (platformObj.default_show) {
self.platform_key = platformObj.key
self.platform = platformObj
}
}

if (self.platforms.length === 0) {
self.$router.replace({
path: '/error',
query: {
title: '暂无可用通道',
description1: '订单：' + platforms.app_order_no,
description2: '支付类型：' + platforms.type
}
})
return
} else if (self.platforms.length === 1) {
self.platform_key = self.platforms[0].key
self.platform_name = self.platforms[0].value
} else if (self.platforms.length > 1) {
self.showChoosePlatform = true
self.showPlatform = false
}

self.checkBank()
}

if (platforms.amount === null || platforms.amount === '' || platforms.amount === '0.00') {
self.showAmountInput = true
} else {
self.showAmountInput = false
self.show_amount = platforms.amount
}

self.app_order_no = platforms.app_order_no
self.yourname = platforms.username

if (!(self.showChoosePlatform === true || self.showBankSelect === true || self.showAmountInput === true || self.platform_key === 88 || self.platform_key === 112 || self.platform_key === 180)) {
self.check()
}
})
},
methods: {
checkBank () {
this.showBankSelect = false
this.banks = []
for (let platform of this.platforms) {
if (platform.key === this.platform_key && platform.need_bank === 1) {
this.bank_id = platform.bank_id
if (platform.bank_id === '') {
this.showBankSelect = true
let banks = []
for (let id in platform.banks) {
let val = platform.banks[id]
banks = banks.concat([{
key: id,
value: val.name
}])
}
this.banks = banks
}
}
}
},
check () {
var submitAmout = Math.max(this.amount, this.input_amount)
submitAmout = Math.max(this.show_amount, submitAmout)
var minLoad = this.platforms_hash[this.platform_key].min_load
var maxLoad = this.platforms_hash[this.platform_key].max_load
var needname = this.platforms_hash[this.platform_key].need_name
var needmobile = this.platforms_hash[this.platform_key].need_mobile
if (this.platform_key === 88 && this.name === '') {
this.$vux.toast.show({
'text': '请输入付款银行卡姓名！',
'type': 'warn'
})
return
}
if (this.platform_key === 112 && this.bank_card_no === '') {
this.$vux.toast.show({
'text': '请输入付款卡卡号！',
'type': 'warn'
})
return
}
if (this.platform_key === 180 && this.bank_card_no === '') {
this.$vux.toast.show({
'text': '请输入付款卡卡号！',
'type': 'warn'
})
return
}
if (needname === 1 && this.yourname === '') {
this.$vux.toast.show({
'text': '请输入您的真实姓名！',
'type': 'warn'
})
return
}
if (needname === 1 && this.yourname !== '') {
cookie.set('yourname', this.yourname, {
expires: 86400 * 30
})
}
if (needmobile === 1 && this.mobileno === '') {
this.$vux.toast.show({
'text': '请输入您的手机号码！',
'type': 'warn'
})
return
}
if (needmobile === 1 && this.mobileno !== '') {
cookie.set('mobileno', this.mobileno, {
expires: 86400 * 30
})
}
if (submitAmout >= minLoad && submitAmout <= maxLoad) {
if (submitAmout % 1 === 0) {
this.submit(submitAmout)
} else {
this.$vux.toast.show({
'text': '请输入整数',
'type': 'warn'
})
}
} else {
var name = this.platforms_hash[this.platform_key].value
this.$vux.alert.show({
content: name + '充值支持 ' + minLoad + '元 ~ ' + maxLoad + '元'
})
}
},
submit (submitAmout) {
const self = this
self.pay_click = true

self.$models.Deposit.create({
order_no: self.$route.query.order_no,
valid: self.$route.query.valid,
platform_id: self.platform_key,
bank_id: self.bank_id,
bank_name: self.name,
amount: submitAmout,
bank_card_no: self.bank_card_no,
name: self.yourname,
mobile: self.mobileno
}).then(function (response) {
self.pay_click = false
if (!response.data.success) {
self.$vux.toast.show({
'text': response.data.message,
'type': 'warn'
})









return
}

cookie.remove('historys')

self.load_url = response.data.data.load_url

if (response.data.data.load_straight === 1) {
window.location.href = self.load_url
self.showAsk()
return
} else if (response.data.data.load_straight === 2) {
self.$router.replace({
path: './qrcode',
query: {
qrcode: response.data.data.load_url,
deposit_type: response.data.data.deposit_type,
platform_id: self.platform_key,
from_url: self.$route.path
}
})
return
}


self.showPayPage = true

self.$vux.loading.show({
text: 'Loading'
})
setTimeout(() => {
self.$vux.loading.hide()
}, 3000)
})
},
showAsk () {
const self = this
self.$vux.confirm.show({
content: '请在新开窗口中完成支付<br />若已完成，请点击“完成支付"',
confirmText: '完成支付',

onCancel () {

},
onConfirm () {
self.payComplete()

}
})
},
changePlatform (e) {
const self = this
if (self.platforms_hash.hasOwnProperty(e)) {
let platform = self.platforms_hash[e]
self.platform = platform
if (self.platform.key === 12) {
self.amountList = self.qqAmountList
} else {
self.amountList = platform.amount_list == null ? self.defaultAmountList : platform.amount_list
}
self.show_amount_input = (platform.static_amount === 0)
if (self.amount_index === -1) {
self.amount_index = 0
}
self.amount = self.amountList[self.amount_index]
self.showContent(self.platform)
if (platform.need_name === 1) {
self.showname = true
if (typeof cookie.get('yourname') === 'string') {
self.yourname = cookie.get('yourname')
}
console.log(cookie.get('yourname'))
} else {
self.showname = false
self.yourname = self.getUserName()
}
if (platform.need_mobile === 1) {
self.showmobile = true
if (typeof cookie.get('mobileno') === 'string') {
self.mobileno = cookie.get('mobileno')
}
} else {
self.showmobile = false
self.mobileno = ''
}
}
self.showPlatform = false
},
showContent (platform) {
const self = this
if (platform.show) {
self.show_list = false
switch (platform.show.type) {
case 'qr':
self.showQrCode(platform)
break
case 'url':
self.showUrl(platform)
break
}
} else {
self.show_list = true
}
},
showQrCode (platform) {
const self = this
self.platform_show = platform.show
},
showUrl (platform) {
const self = this
self.platform_show = platform.show
},
navToPay () {
const self = this
window.location.href = self.platform_show.link
},
payComplete () {
const self = this
self.showPayPage = false
self.$router.replace({
path: '/deposit/list'
})
},
checkOrderCounts () {
const history = cookie.get('historys')
if (typeof history !== 'undefined') {
console.log('historys in 5mins count:' + Object.keys(JSON.parse(history)).length)
if (Object.keys(JSON.parse(history)).length > 50) {
this.$router.replace({
path: '/error',
query: {
title: '订单发起过于频繁',
description1: '对不起，因您频繁发起订单但未提交支付',
description2: '请您休息五分钟再尝试，谢谢您的配合'
}
})
return false
}
}

if (typeof this.$route.query.order_no !== 'undefined') {
this.setOrderCounts()
}
},
setOrderCounts () {
var historys = {}
if (typeof cookie.get('historys') !== 'undefined') {
historys = JSON.parse(cookie.get('historys'))
console.log(historys)
}

historys[this.$route.query.order_no] = true

var expire = new Date()
expire.setMinutes(expire.getMinutes() + 5)
cookie.set('historys', JSON.stringify(historys), {
expires: expire,
raw: true
})
},
getUserName () {
return this.yourname.length ? this.yourname : ''
}
}
}



// WEBPACK FOOTER //
// ./src/components/Deposit1.vue